var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0577 12.1251C17.116 15.7001 13.866 18.3334 9.99935 18.3334C5.39935 18.3334 1.66602 14.6334 1.66602 10.0001C1.66602 4.44175 6.29935 1.66675 6.29935 1.66675M6.29935 1.66675L2.49935 1.66675M6.29935 1.66675L6.29935 3.34175L6.29935 5.36675",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66656C14.6 1.66656 18.3333 5.3999 18.3333 9.9999",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.5 2.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45898 10L8.81732 12.3584L13.5423 7.64169",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseStatus);
export default __webpack_public_path__ + "static/media/close-status.f996987f42c4f0853b6a901196897646.svg";
export { ForwardRef as ReactComponent };